import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';

const ToolHeader = ({ title, filename }) => {
  const { t } = useLanguage();

  return (
    <motion.div 
      className="flex items-center justify-between p-4 border-b border-gray-200"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h3 className="text-lg font-semibold text-gray-800">
        {title}
      </h3>
      
      {filename && (
        <motion.div 
          className="text-sm text-gray-600"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
        >
          <span className="font-medium">{t('selectedFile')}:</span> {filename}
        </motion.div>
      )}
    </motion.div>
  );
};

export default ToolHeader;